import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";
import Header from "../../../component/Header";
import { AppContext } from "../../../context/app-context";
import { convertUTCtoLocalDate } from "../../../helper";
import { sendFirebaseEvent } from "../../../helper/mobile";

const RiskAssessmentList = () => {
    const [state, dispatch] = useContext(AppContext);
    const data = state.riskAssessment.preRiskAssessment;
    return(
        <>
            <Header title="Risk score" />
            <Container>
                <Link to="/riskAssessment/yourScore" className="risk-list-card-link" onClick={() => sendFirebaseEvent('ra_risk_assessemnt_list_click', 'click_event')}>
                    <Card className="mt-4 risk-list-card">
                    <Row>
                        <Col xs={8}>
                        <h3 className="mb-0 text-capitalize">{data.assessmentType}</h3>
                        <p className="h3-sub-text mb-0">Updated on {convertUTCtoLocalDate(data.createdAt)}</p>
                        </Col>
                        <Col xs={4} className="text-center">
                        <h2 className={`mb-0 green ${data.assessmentScore < 5 ? 'green' : 'red'}`}>{data.assessmentScore}</h2>
                        <p className="h2-sub-text mb-0">RISK SCORE</p>
                        </Col>
                    </Row>
                    </Card>
                </Link>
            </Container>
        </>
    )
}

export default RiskAssessmentList